import { Exclude } from 'class-transformer';

export class FileWithoutStream {
  @Exclude()
  _writeStream: unknown;
}
